/**
 * Скрывает элемент интерфейса, если права нет.
 *
 * Скрытие кнопки — не защита (§1.4). Сервер обязан отказать независимо от того,
 * что показал клиент. Это только про то, чтобы не предлагать заведомо
 * недоступное действие.
 */

import type { Permission } from "@taskflow/contracts";
import type { ReactNode } from "react";

import { useAppSelector } from "@/app/hooks";

import { canAny } from "@taskflow/client-core";

interface PermissionGateProps {
  /** Достаточно любого из перечисленных прав. */
  permission: Permission | Permission[];
  /** Права на текущей доске, если экран привязан к доске. */
  boardPermissions?: readonly Permission[];
  children: ReactNode;
  /** Что показать вместо содержимого. По умолчанию — ничего. */
  fallback?: ReactNode;
}

export function PermissionGate({
  permission,
  boardPermissions,
  children,
  fallback = null,
}: PermissionGateProps) {
  const system = useAppSelector((state) => state.auth.permissions);
  const required = Array.isArray(permission) ? permission : [permission];
  const allowed = canAny(
    boardPermissions ? { system, board: boardPermissions } : { system },
    required,
  );
  return <>{allowed ? children : fallback}</>;
}
